export default {"src":"/_next/static/media/toilet.48877815.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};